<template>
  <hi-data-list-kit
    :search-fn="projectListSearchFn"
    :sortables="projectSortRules"
    @select="onSelect"
    :filter-value="filterOwner"
    filter-key="mainOwner"
    search-input-placeholder="Name, Address or Type"
    :current-id="projectsState.currentProjectId"
  >
    <template v-slot:filterArea>
      <hi-select
        v-model="filterOwner"
        placeholder="Main Owner..."
        :items="userNoMaintenance"
        no-form
      />
    </template>
    <template v-slot="{ item }">
      <project-summary :project-data="item" />
    </template>
  </hi-data-list-kit>
</template>

<script>
import {
  projectListSearchFn,
  projectSortRules,
  provideWinProjectsListStore,
} from "@/hive-vue3/modules/projects/data";
import ProjectSummary from "@/hive-vue3/modules/projects/ProjectSummary";
import { projectsState } from "@/hive-vue3/modules/projects/state";
import HiDataListKit from "@/hive-vue3/components/dataDisplay/HiDataListKit";
import HiSelect from "@/hive-vue3/components/form/controls/HiSelect";
import { computed, ref } from "vue";
import { useSystemUsers } from "@/hive-vue3/firebase";
export default {
  name: "ProjectsWinList",
  components: { HiSelect, HiDataListKit, ProjectSummary },
  setup() {
    provideWinProjectsListStore();

    function onSelect(item) {
      projectsState.currentProjectId = item.id;
    }

    const filterOwner = ref(undefined);
    const users = useSystemUsers();
    const userNoMaintenance = computed(() => {
      const returnArr = [{ text: "NAN", value: "noFilter" }];
      for (const i in users) {
        if (users[i].roles.indexOf("maintenance") === -1) {
          returnArr.push({
            text: users[i].name,
            value: users[i].id,
          });
        }
      }
      return returnArr;
    });

    return {
      onSelect,
      projectListSearchFn,
      projectSortRules,
      projectsState,
      userNoMaintenance,
      filterOwner,
    };
  },
};
</script>

<style scoped></style>
